import React, {ReactNode} from "react";
import Image from "next/image";
import {useRouter} from "next/router";
import {useTranslation} from "next-i18next";
import {Button} from "antd";
import RedoOutlined from "@ant-design/icons/RedoOutlined";

type Props = {
	errorCode?: number;
	children?: React.ReactNode;
	className?: string;
	title?: string;
	subtitle?: string;
	backButton?: ReactNode;
}

export default function DashboardError(props: Props) {
	const router = useRouter();

	const {t} = useTranslation();

	const errorCode = props.errorCode || 404;
	const title = props.title || t(`base-common:error.${errorCode}.title`);
	const subtitle = props.subtitle || t(`base-common:error.${errorCode}.subtitle`);

	const goBack = () => {
		if (router.query.hasOwnProperty('redirect_back') && router.query.redirect_back && router.query.redirect_back.length > 0)
		{
			router.push(router.query.redirect_back as string);
		}
		else
		{
			router.back();
		}
	}

	const refresh = () => {
		const backPath = router.query.from || (window && window.location && window.location.pathname);

		console.debug(router.query.from)
		router.push(backPath as string);
	}

	const backButton = props.backButton || (
		<Button type={`primary`} size={`large`} onClick={goBack}>
			{t('base-common:button.back-router')}
		</Button>
	);

	const reloadButton = props.backButton || (
		<Button type={`primary`} size={`large`} onClick={refresh}>
			<RedoOutlined/>
		</Button>
	);

	return (
		<div className={`flex flex-col justify-center items-center text-center h-full ${props.className}`}>
			<div className={`max-w-screen-sm space-y-4`}>
				<Image src={`/image/${errorCode}.webp`} alt="hero" width={1} height={1} layout={"responsive"}/>
				<p className="text-2xl font-bold mt-5">{title}</p>
				<p className="text-xl font-medium mt-2 mb-2">{subtitle}</p>
				<div className={`gap-4 flex items-center justify-center`}>
					{backButton}
					{reloadButton}
				</div>
				{props.children}
			</div>
		</div>
	)
}